// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3M7zy","buttons":"PendingPaymentAlert_buttons__369t2"};